import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MapaOlComponent } from './mapa-ol/mapa-ol.component';

const routes: Routes = [
  { path: '', title: 'Mapa', component: MapaOlComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MapaRoutingModule {}
